import Vue from 'vue';
import moment from 'moment';
export default Vue.extend({
    props: {
        salesPartnerPayouts: {
            type: Array,
            required: true,
        },
    },
    computed: {
        dataForCsv() {
            const self = this;
            if (self.salesPartnerPayouts.length >= 1) {
                return self.salesPartnerPayouts.map((payout) => {
                    return {
                        billingMonth: this.getBillingMonth(payout.billingPeriodStartAt),
                        billingNumber: payout.referenceNumber,
                        billingPeriod: `${payout.formattedBillingStartDate} - ${payout.formattedBillingEndDate}`,
                        tierType: payout.humanizedTierType,
                        totalBillingAmount: payout.currentAmount,
                        dueDate: payout.formattedBillingDueDate,
                        paymentDateAndTime: payout.formattedPaymentReceivedAt,
                        commissionAmount: payout.salesPartnerCommission,
                        status: payout.collected ? 'Collected' : 'For Collection',
                    };
                });
            }
            return [];
        },
    },
    methods: {
        getBillingMonth(billingStartDate) {
            const format = 'MMMM';
            return moment(billingStartDate).format(format);
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                salesPartnerPayouts: self.dataForCsv,
            });
        }
    },
});
